module.exports = __webpack_public_path__ + "static/media/SV1_03_Protection_200.65c43135.jpg";